import { render, staticRenderFns } from "./pie-chart.vue?vue&type=template&id=59630046&scoped=true"
import script from "./pie-chart.vue?vue&type=script&lang=js"
export * from "./pie-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59630046",
  null
  
)

export default component.exports